const selectors = {
  productContainer: document.querySelector('[data-product-container]'),
  pdpStickyBuyButton: document.querySelector('[data-buy-buttons-container] div.product-atc-form'),
  pdpStickyBuyButtonContainer: document.querySelector('[data-buy-buttons-container]')
};

class TemplateProductJS {
  constructor() {
    this.abortController = undefined;
    this.pendingRequestUrl = null;
    this.container = selectors.productContainer;
    this.chatBtn=document.querySelector('[chat-with-us]');
    this.chatBtn?.addEventListener('click', this.handleChatBox.bind(this));
    // Product page option change event to update dynamic data
    eventBus.subscribe(THEME_EVENTS.optionChange, (eventData) => {
      const { target, selectedOptionsId } = eventData.data;
      this.handleOptionValueChange(target, selectedOptionsId);
    });

    if(selectors.pdpStickyBuyButtonContainer){
      this.stickyBuyButton();
    }
  }

  addPreProcessCallback(callback) {
    this.preProcessHtmlCallbacks.push(callback);
  }

  handleOptionValueChange(target, selectedOptionsId){
    // console.log('correct request====>', this.container.contains(target));
    if (!this.container.contains(target)) return;

    const productUrl = target.dataset.productUrl || this.container.pendingRequestUrl || this.container.dataset.url;
    this.pendingRequestUrl = productUrl;
    const swapProduct = this.container.dataset.url !== productUrl;
    const fetchFullPage = this.container.dataset.updateUrl === 'true' && swapProduct;

    this.renderProductInfo({
      requestUrl: this.buildRequestUrlWithParams(productUrl, selectedOptionsId, fetchFullPage),
      targetId: target.id,
      callback: swapProduct
        ? this.handleSwapProduct(productUrl, fetchFullPage)
        : this.handleUpdateProductInfo(productUrl),
    });
  }

  handleChatBox(){
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  }

  renderProductInfo({ requestUrl, targetId, callback }) {
    this.abortController?.abort();
    this.abortController = new AbortController();

    fetch(requestUrl, { signal: this.abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        this.pendingRequestUrl = null;
        const html = new DOMParser().parseFromString(responseText, 'text/html');
        callback(html);
      })
      .then(() => {
        // set focus to last clicked option value
        document.querySelector(`#${targetId}`)?.focus();
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          console.log('Fetch aborted by user');
        } else {
          console.error(error);
        }
      });
  }

  handleSwapProduct(productUrl, updateFullPage) {
    // console.log(productUrl, updateFullPage);
  }

  handleUpdateProductInfo(productUrl){
    return (html) => {
      // console.log(productUrl, html);
      const productId = this.container.dataset.product;
      const updateSourceFromDestination = (selector) => {
        const source = html.querySelector(selector);
        const destination = this.container.querySelector(selector);

        if (source && destination) {
          destination.innerHTML = source.innerHTML;
          destination.classList.remove('d-none');
        } else if (destination) {
          destination.classList.add('d-none');
        }
      };

      updateSourceFromDestination(`#Inventory-${productId}`);
      updateSourceFromDestination(`#Sku-${productId}`);
      updateSourceFromDestination(`#Quantity-${productId}`);
      updateSourceFromDestination(`#Volume-discount-${productId}`);
      // Update product key highlights (metal, diamond size, ring size) when variant changes
      updateSourceFromDestination(`#ProductStoneHighlights-${productId}`);
    }
  }

  buildRequestUrlWithParams(url, optionValues, fetchFullPage = false) {
    const params = [];
    !fetchFullPage && params.push(`section_id=${this.container.dataset.section}`);
    if (optionValues.length) {
      params.push(`option_values=${optionValues.join(',')}`);
    }
    return `${url}?${params.join('&')}`;
  }

  // Sticky checkout container on oage scroll
  stickyBuyButton(){
    const htmlEl = document.documentElement;
    const stickyEl = selectors.pdpStickyBuyButton;
    const targetEl = selectors.pdpStickyBuyButtonContainer;

    if (!stickyEl || !targetEl) return;

    const applyHtmlPadding = () => {
      if (!stickyEl.classList.contains('pdp-sticky-buy-button')) {
        htmlEl.style.paddingBottom = '';
        return;
      }

      const height = Math.ceil(stickyEl.getBoundingClientRect().height || 0);
      htmlEl.style.paddingBottom = height ? `${height}px` : '';
    };

    const buyButtonObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          let elementTop = targetEl.getBoundingClientRect().top;
            if(entry.isIntersecting){
                stickyEl.classList.remove('pdp-sticky-buy-button');
            } else {
              if(elementTop < 0){
                stickyEl.classList.add('pdp-sticky-buy-button');
              }
            }
            applyHtmlPadding();
        })
    });
    buyButtonObserver.observe(targetEl);

    // Keep padding in sync if sticky bar height changes (responsive / dynamic updates)
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(() => applyHtmlPadding());
      ro.observe(stickyEl);
    } else {
      window.addEventListener('resize', applyHtmlPadding);
    }

    // Initial run (covers cases where page loads already scrolled)
    applyHtmlPadding();
  }
}

typeof TemplateProductJS !== 'undefined' && new TemplateProductJS();




class CustomEngraving extends HTMLElement {
  constructor() {
    super();

    // Query the input element 
    this.input = this.querySelector("input[type='text']");
    this.font_size= this.querySelectorAll("[data-engraving-size] input[type='radio']")
    this.font_style= this.querySelectorAll("[data-engraving-font] input[type='radio']")
    this.cartElement = document.querySelector('cart-form');
    this.engraving_fees = this.input.dataset.fees;
    this.variantRadioOptions = this.querySelectorAll('[data-engraving-font], [data-engraving-size], fieldset');

    // Query the character count display element
    this.charCount = this.querySelector("[character-count]");
    this.charCountText = this.querySelector(".char-count-text");
    this.textOverlay = this.querySelector(".text-overlay");
    if (this.input) {
      this.input.addEventListener("input", this.inputChange.bind(this));
    }
   
    this.font_size.forEach((element) => {
      element.addEventListener("change", (event) => {
        this.manageFontSize(event);
      });
    });

    this.font_style.forEach((element) => {
      element.addEventListener("change", (event) => {
        this.manageFontStyle(event);
      });
    });

    this.variantRadioOptions.forEach((element) => {
      element.addEventListener("change", (event) => {
        const formLabel = event.currentTarget.querySelector(".bs-form-label");
        // Check if the label contains the radio button element and remove the 'text-danger' class
        if (formLabel?.classList.contains("text-danger")) {
          formLabel.classList.remove("text-danger");
        }
      });
    });
    
    
  }

  manageFontStyle(event) {
    const fontClassPrefix = "engraving_";

    // Remove existing font-related classes
    this.textOverlay.classList.forEach((cls) => {
      if (cls.startsWith(fontClassPrefix)) {
        this.textOverlay.classList.remove(cls);
      }
    });

    // Add the new font class from the selected value
    const newFontClass = event.currentTarget.dataset.css_class;
    if (newFontClass) {
      this.textOverlay.classList.add(newFontClass);
    }
  }

  manageFontSize(event) {

    const sizeClassPrefix = "fs-";

    // Remove existing size-related classes
    this.textOverlay.classList.forEach((cls) => {
      if (cls.startsWith(sizeClassPrefix)) {
        this.textOverlay.classList.remove(cls);
      }
    });

    // Add the new size class from the selected value
    const newSizeClass = event.currentTarget.value;
    if (newSizeClass) {
      this.textOverlay.classList.add(newSizeClass);
    }
  }


  inputChange() {
    // Get the current value of the input
    const text = this.input.value;

    // Show character count text on first input (safe if element doesn't exist)
    if (this.charCountText?.classList.contains('d-none')) {
      this.charCountText.classList.remove('d-none');
    }
    // Update the character count display
    if (this.charCount) {
      this.charCount.textContent = `${text.length}/15`;
    }

    // Update the text overlay on the image
    // INP: CircleType splits text into per-letter spans and measures them; render once per frame, not per keystroke
    if (this.textOverlay && !this.overlayFrame) {
      this.overlayFrame = requestAnimationFrame(() => {
        this.overlayFrame = null;
        const latestText = this.input.value;
        this.textOverlay.textContent = latestText;
        if (typeof CircleType === 'function') new CircleType(this.textOverlay).radius(350).dir(-1);
        if (latestText.length > 10 && latestText.length <= 14) this.textOverlay.style.top = '42%';
      });
    }

    let variantsHasRadioOptions = true;
    if (this.variantRadioOptions.length > 0) {
      
      this.variantRadioOptions.forEach(ele => {
        if (ele.querySelector('input:checked') == null) {
          ele.querySelector('.bs-form-label').classList.add('text-danger');
          variantsHasRadioOptions = false;
          return false
        } else {
          ele.querySelector('.bs-form-label').classList.remove('text-danger')
        }
      });
    }
  
  }
}

// Define the custom element
customElements.define("custom-engraving", CustomEngraving);


class imageZoomJS {
  constructor() {
    this.overlay = null;
    this.enableZoomOnHover(2);
  }
  // create a container and set the full-size image as its background
  createOverlay = (image) => {
    const overlayImage = document.createElement('img');
    overlayImage.setAttribute('data-overlay', true)

    overlayImage.setAttribute('src', `${image.src}`);
    this.overlay = document.createElement('div');
    this.prepareOverlay(this.overlay, overlayImage);

    image.style.opacity = '50%';

    image.parentElement.insertBefore(this.overlay, image);
    image.style.opacity = '100%';

    return this.overlay;
  };

  prepareOverlay = (container, image) => {
    let newSrc = image.src.split('&width')[0];
    container.setAttribute('class', 'image-magnify-full-size');
    container.setAttribute('aria-hidden', 'true');
    container.style.backgroundImage = `url('${newSrc}')`;
    //container.style.backgroundColor = 'var(--bs-color-secondary)';
  }

  moveWithHover = (image, event, zoomRatio) => {
    const zr = (typeof zoomRatio === 'number' && Number.isFinite(zoomRatio) && zoomRatio > 0) ? zoomRatio : 2;
    // calculate mouse position
    const ratio = image.height / image.width;
    const container = event.target.getBoundingClientRect();
    const xPosition = event.clientX - container.left;
    const yPosition = event.clientY - container.top;
    const xPercent = `${xPosition / (image.clientWidth / 100)}%`;
    const yPercent = `${yPosition / ((image.clientWidth * ratio) / 100)}%`;

    // determine what to show in the frame
    this.overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
    this.overlay.style.backgroundSize = `${image.width * zr}px`;
  };

  magnify = (image, zoomRatio) => {
    this.overlay = this.createOverlay(image);
    this.overlay.onclick = () => this.overlay.remove();
    this.overlay.onmousemove = (event) => this.moveWithHover(image, event, zoomRatio);
    this.overlay.onmouseleave = () => this.overlay.remove();
  }
  enableZoomOnHover = (zoomRatio = 2) => {
    const images = document.querySelectorAll('.image-magnify-hover');
    images.forEach(image => {
      image.onclick = (event) => {
        this.magnify(image, zoomRatio);
        this.moveWithHover(image, event, zoomRatio);
      };
    });
  }
}

typeof imageZoomJS !== 'undefined' && new imageZoomJS();

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.modelBody = document.querySelector('#zoom-productmedia .modal-body');
    this.button.addEventListener('click', this.openProductmedia.bind(this));
    this.modal = document.querySelector('#zoom-productmedia .modal');
    this.modalDialog = document.getElementById('zoom-productmedia');

  }

  /** Escape text for use in HTML attribute values */
  static escapeAttr(value) {
    if (value == null || value === '') return '';
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/"/g, '&quot;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;');
  }

  resolveModalSlideIndex() {
    const mediaEl =
      this.querySelector('[data-media-id]') || this.querySelector('[data-mediaid]');
    const mediaId =
      mediaEl?.getAttribute('data-media-id') ?? mediaEl?.getAttribute('data-mediaid');
    if (mediaId && Array.isArray(this.ProductMedia)) {
      const idx = this.ProductMedia.findIndex((m) => String(m.id) === String(mediaId));
      if (idx >= 0) return idx;
    }
    const parsed = parseInt(this.dataset.index, 10);
    return Number.isNaN(parsed) ? 0 : parsed;
  }

  syncModalMainSlide(mainEl, slideIndex) {
    const apply = () => {
      const sw = mainEl.swiper;
      if (!sw) return;

      const playTargetSlide = () => {
        const targetSlide = sw.slides?.[slideIndex] || sw.slides?.[sw.activeIndex];
        this.handleZoomSlideMedia(targetSlide, true);
      };

      if (sw.activeIndex === slideIndex) {
        playTargetSlide();
        return;
      }

      sw.slideTo(slideIndex, 0);
      requestAnimationFrame(playTargetSlide);
    };
    if (mainEl.swiper) apply();
    else mainEl.addEventListener('swiper:init', apply, { once: true });
  }

  handleZoomSlideMedia(slideEl, shouldPlay) {
    if (!slideEl) return;

    const customVideo = slideEl.querySelector?.('custom-video');
    if (customVideo) {
      try {
        if (shouldPlay) customVideo.showContent?.();
        else customVideo.hideContent?.();
      } catch (_) {}
      return;
    }

    const video = slideEl.querySelector?.('video');
    if (video) {
      try {
        if (shouldPlay) {
          video.muted = true;
          video.playsInline = true;
          video.play?.().catch(() => {});
        } else {
          video.pause?.();
        }
      } catch (_) {}
    }
  }

  bindZoomModalSlideMedia(mainEl) {
    if (!mainEl || mainEl.dataset.zoomSlideMediaBound === 'true') return;

    const bind = () => {
      const sw = mainEl.swiper;
      if (!sw) return;

      // Slide play on first open is handled by syncModalMainSlide after slideTo.
      mainEl.addEventListener('swiperslidechange', ({ detail }) => {
        const swiperInstance = detail && detail[0];
        if (!swiperInstance) return;

        const { activeIndex, previousIndex, slides } = swiperInstance;
        if (!slides || activeIndex == null || previousIndex == null) return;

        const prevSlide = slides[previousIndex];
        const activeSlide = slides[activeIndex];
        this.handleZoomSlideMedia(prevSlide, false);
        this.handleZoomSlideMedia(activeSlide, true);
      });
    };

    if (mainEl.swiper) bind();
    else mainEl.addEventListener('swiper:init', bind, { once: true });

    mainEl.dataset.zoomSlideMediaBound = 'true';
  }

  /**
   * Swiper Element resolves navigation selectors on the host first; zoom modal arrows sit
   * outside <swiper-container>, so built-in navigation can bind to the wrong swiper (e.g. thumbs).
   * Wire prev/next explicitly to the main modal instance once.
   */
  bindZoomModalMainNavigation(mainEl) {
    const modal = this.modal;
    if (!modal || !mainEl) return;

    const prev = modal.querySelector('.pdp-zoom-modal-prev');
    const next = modal.querySelector('.pdp-zoom-modal-next');
    if (!prev || !next || prev.dataset.pdpZoomNavBound === 'true') return;

    const bind = () => {
      const sw = mainEl.swiper;
      if (!sw) return;

      const onPrev = (e) => {
        e.preventDefault();
        sw.slidePrev();
      };
      const onNext = (e) => {
        e.preventDefault();
        sw.slideNext();
      };
      prev.addEventListener('click', onPrev);
      next.addEventListener('click', onNext);
      prev.dataset.pdpZoomNavBound = 'true';
      next.dataset.pdpZoomNavBound = 'true';
    };

    if (mainEl.swiper) bind();
    else mainEl.addEventListener('swiper:init', bind, { once: true });
  }

  async openProductmedia() {
    // INP: let the tap paint before building/injecting the zoom gallery and its swipers
    await Utility.yieldToMain();

    const media = globalThis.themeData.product.media;
    const images = [];
    let video = null;

    media.forEach((ele) => {
      if ((ele.media_type === 'video' || ele.media_type === 'external_video') && !video) {
        video = ele;
      } else if (ele.media_type === 'image') {
        images.push(ele);
      }
    });

    if (video && images.length >= 1) {
      images.splice(1, 0, video);
    } else if (video) {
      images.push(video);
    }

    this.ProductMedia = images;
    const productTitle = ModalOpener.escapeAttr(globalThis.themeData.product?.title ?? '');
    const totalSlides = this.ProductMedia.length;

    let mainSlidesHtml = '';
    let thumbsSlidesHtml = '';

    this.ProductMedia.forEach((ele, slideIdx) => {
      const posLabel = `${slideIdx + 1} / ${totalSlides}`;
      if (ele.media_type === 'image') {
        const imgW = Number(ele.preview_image?.width) || Number(ele.width) || 1;
        const imgH = Number(ele.preview_image?.height) || Number(ele.height) || 1;
        mainSlidesHtml += `<swiper-slide class="align-items-center product--media" data-mediaid="${ele.id}" role="group" aria-label="${ModalOpener.escapeAttr(posLabel)}">
                    <div class="position-relative overflow-hidden d-flex align-items-center justify-content-center">
                      <img src="${ele.src}" alt="${productTitle}" width="${imgW}" height="${imgH}" loading="lazy" class="w-100 image-magnify-hover pdp-zoom-modal-main__img">
                    </div>
                  </swiper-slide>`;

        thumbsSlidesHtml += `<swiper-slide>
            <div class="product-thumb--image d-flex" data-index="${slideIdx + 1}" data-mediaid="${ele.id}" role="group" aria-label="${ModalOpener.escapeAttr(posLabel)}">
              <div class="product-thumb w-100 h-100 position-relative overflow-hidden">
                <img class="img-fluid" src="${ele.src}" sizes="250px" loading="lazy" width="250" height="250" alt="${productTitle}">
              </div>
            </div>
          </swiper-slide>`;
      } else if (ele.media_type === 'external_video' || ele.media_type === 'video') {
        let VideoType = '';
        let videoId = '';
        if (ele.media_type === 'external_video') {
          if (ele.host === 'youtube') {
            VideoType = 'youtube';
            videoId = ele.external_id;
          } else if (ele.host === 'vimeo') {
            VideoType = 'vimeo';
            videoId = ele.external_id;
          }
        } else if (ele.media_type === 'video') {
          const src =
            ele.sources?.[1]?.url || ele.sources?.[0]?.url || '';
          videoId = src;
          VideoType = 'local';
        }
        mainSlidesHtml += `<swiper-slide class="align-items-center product--media h-auto" data-mediaid="${ele.id}" role="group" aria-label="${ModalOpener.escapeAttr(posLabel)}">
          <div class="h-100 position-relative w-100">
              <div class="custom-video-container w-100 h-100 position-relative">
                ${
                  VideoType === 'vimeo'
                    ? `<iframe class="pf-ifr w-100 h-100 rounded-1" src="https://player.vimeo.com/video/${ModalOpener.escapeAttr(videoId)}?autoplay=1&loop=1&autopause=0&muted=1" width="400" height="400" frameborder="0" allow="autoplay; fullscreen" allowfullscreen title="vimeo-video"></iframe>`
                    : `<custom-video class="placement--grid" data-video-type="${VideoType}" data-video-id="${ModalOpener.escapeAttr(videoId)}" data-muted="true" data-placement="grid" data-autoplay="true" data-controls="true" data-loop="true" data-pdp-slider-video="true">
                  <div class="content-section overflow-hidden rounded-1 h-100">
                    <div class="poster-image">
                      <img
                        src="${ele.preview_image.src}"
                        loading="eager"
                        alt="${productTitle}"
                        width="${ele.preview_image.width}"
                        height="${ele.preview_image.height}">
                    </div>
                  </div>
                  <div class="video-section w-100 h-100" aria-hidden="true" inert></div>
                </custom-video>`
                }
              </div>
            </div>
          </swiper-slide>`;
        thumbsSlidesHtml += `<swiper-slide>
              <div class="product-thumb--image media--video d-flex" data-index="${slideIdx + 1}" data-mediaid="${ele.id}" role="group" aria-label="${ModalOpener.escapeAttr(posLabel)}">
                <div class="product-thumb  w-100 h-100 position-relative d-inline-flex align-items-center justify-content-center overflow-hidden">
                  <img class="img-fluid" src="${ele.preview_image.src}" sizes="250px" loading="lazy" width="250" height="250" alt="${productTitle}">
                  <span class="icon-play position-absolute start-0 end-0 m-auto top-0 bottom-0 d-flex align-items-center justify-content-center">
                      <svg aria-hidden="true" focusable="false" style="width:24px;height:24px;"><use href="#icon-play"></use></svg>
                  </span>
                </div>
              </div>
            </swiper-slide>`;
      }
    });

    const finalHtml = `
        <div class="modal-dialog modal-dialog-centered w-100 m-0" data-zoom-gallery-modal>
          <div class="modal-content rounded-0 border-0">
              <div class="modal-body p-5 position-relative d-flex align-items-center">
                <button type="button" class="position-fixed bg-primary-100 text-body close btn rounded-circle d-flex align-items-center justify-content-center" id="ModalClose-ProductPopup-DropHint" aria-label="Close">
                   <svg width="12" height="12" viewBox="0 0 24 24" class="h-auto w-auto">
                      <use href="#icon-close"></use>
                  </svg>
                </button>
                <div class="container product-modal-body">
                    <div class="row">
                      <div class="col-xl-11 m-auto">
                        <div class="d-flex swiper-wrapper__custom--main justify-content-center">
                          <div class="swiper-wrapper__custom col-lg-8 pdp-modal-slider position-relative d-flex align-items-center">
                            <div class="custom-swiper-navigation both d-flex gap-2">
                              <button type="button" aria-label="Previous slide" class="swiper-button-prev pdp-zoom-modal-prev"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-left"></use></svg></button >
                              <button type="button" aria-label="Next slide" class="swiper-button-next pdp-zoom-modal-next"><svg aria-hidden="true" focusable="false"><use href="#icon-arrow-right"></use></svg></button>
                            </div>
                            <swiper-container
                              class="product-slider pdp-zoom-modal-main w-100"
                              thumbs-swiper=".pdp-zoom-modal-thumbs"
                              loop="false"
                              grab-cursor="true"
                              slides-per-view="1"
                              space-between="15"
                              allow-touch-move="true"
                              scrollbar="true"
                              role="tree">
                              ${mainSlidesHtml}
                            </swiper-container>
                          </div>
                          <div class="swiper-wrapper__custom swiper-wrapper__custom--thumbs col-lg-3 mt-0 mt-lg-0 d-flex align-items-center">
                            <swiper-container
                              class="product-image-thumbs pdp-zoom-modal-thumbs w-100"
                              loop="false"
                              slides-per-view="auto"
                              space-between="0"
                              direction="horizontal"
                              watch-slides-progress="true"
                              breakpoints='{"992":{"direction":"vertical"}}'
                              role="tree">
                                    ${thumbsSlidesHtml}
                            </swiper-container>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
          </div>
        </div>`;

    const slideIndex = this.resolveModalSlideIndex();

    if (this.modal) {
      if (this.modal.innerHTML === '') {
        this.modal.innerHTML = finalHtml;
        // Bind hover zoom once on the injected images (constructor calls enableZoomOnHover)
        new imageZoomJS();
      }
      // Use the ModalDialog component so the modal isn't inert and is fully interactive.
      if (this.modalDialog) {
        // Close button is injected dynamically; update reference and bind close behavior once.
        const closeBtn = this.modalDialog.querySelector('[id^="ModalClose-"]');
        if (closeBtn && !closeBtn.dataset.modalBound) {
          closeBtn.addEventListener('click', (e) => {
            e.preventDefault();
            this.modalDialog.hide();
          });
          closeBtn.dataset.modalBound = 'true';
        }
        // Ensure ModalDialog uses the injected close button for focus trap
        if (closeBtn) this.modalDialog.closeBtn = closeBtn;

        // Wrap hide once to restore body scroll state
        if (!this.modalDialog._zoomHideWrapped) {
          const originalHide = this.modalDialog.hide.bind(this.modalDialog);
          this.modalDialog.hide = (...args) => {
            document.body.classList.remove('scroll-fixed');
            return originalHide(...args);
          };
          this.modalDialog._zoomHideWrapped = true;
        }

        this.modalDialog.show(this.button);
      } else {
        // Fallback: make sure it's not inert even if modal-dialog isn't available
        const wrapper = document.getElementById('zoom-productmedia');
        wrapper?.removeAttribute('inert');
        wrapper?.setAttribute('aria-hidden', 'false');
        this.modal.classList.add('open');
      }

      document.body.classList.add('scroll-fixed');
    }

    const mainEl = this.modal?.querySelector('.pdp-zoom-modal-main');
    if (!mainEl) return;

    const afterSwiperReady = () => {
      customElements.whenDefined('swiper-container').then(() => {
        requestAnimationFrame(() => {
          this.syncModalMainSlide(mainEl, slideIndex);
          this.bindZoomModalMainNavigation(mainEl);
          this.bindZoomModalSlideMedia(mainEl);
        });
      });
    };

    if (typeof window.triggerSwiperLoad === 'function') {
      window.triggerSwiperLoad().then(afterSwiperReady).catch(afterSwiperReady);
    } else {
      afterSwiperReady();
    }

  }
  closeProductmedia(event) {
    event.stopImmediatePropagation();
    if (this.modal.classList.contains('open')) {
      this.modal.classList.remove('open');
      document.querySelector('body').classList.remove('scroll-fixed');
    }
  }
}
customElements.define('modal-opener', ModalOpener);